import React from "react";
import gh from "../assets/social_media/gh.png"; // Example image
import ali from "../assets/profilepics/ali.jpg";
import chenghau from "../assets/profilepics/ChengHau.jpg";
import samundra from "../assets/profilepics/samundra.png";
import rtali from "../assets/profilepics/rtali.JPG";
import mehdi from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/mehdi.jpg";
import abhisek from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/abhisekh.jpeg";
import suriya from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/suriya.jpeg";
import marjan from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/marjan.jpeg";
import soumik from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/soumik.jpeg";
import adarsh from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/adarsh.jpeg";
import chinmay from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/chinmay.jpeg";
import balu from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/balu.jpeg";
import baskar from "/Users/samundrakarki/personal_website/research_website/src/assets/profilepics/baskar.png"
const TEAM = () => {
  const teamMembers = [
    { name: "Ronak Tali", image: rtali, link: "https://www.linkedin.com/in/ronaktali/" },
    { name: "Ali Rabeh", image: ali, link: "https://www.linkedin.com/in/alirabeh/" },
    { name: "Cheng-Hau Yang", image: chenghau, link: "https://www.linkedin.com/in/ychenghau/" },
    { name: "Mehdi Shadkhah", image: mehdi, link: "https://www.linkedin.com/in/mehdi-shadkhah/" },
    { name: "Samundra Karki", image: samundra, link: "https://www.linkedin.com/in/samundra-karki-1aa8ab176/" },
    { name: "Abhisek Upadhyaya", image: abhisek, link: "https://www.linkedin.com/in/abhisekupadhyaya/" },
    { name: "Suriya Dhakshinamoorthy", image: suriya, link: "https://www.linkedin.com/in/s-narayanan/" },
    { name: "Marjan Saadati", image: marjan, link: "https://scholar.google.com/citations?user=Xo2rp2EAAAAJ&hl=en&oi=sra" },
    { name: "Soumik Sarkar", image: soumik, link: "https://scholar.google.com/citations?user=-rmRjqIAAAAJ&hl=en&oi=ao" },
    { name: "Adarsh Krishnamurthy", image: adarsh, link: "https://scholar.google.com/citations?user=iVTMSxoAAAAJ&hl=en&oi=ao" },
    { name: "Chinmay Hegde", image: chinmay, link: "https://scholar.google.com/citations?user=eJAV17IAAAAJ&hl=en&oi=ao" },
    { name: "Aditya Balu", image: balu, link: "https://scholar.google.com/citations?user=GNuXi6oAAAAJ&hl=en&oi=ao" },
    { name: "Baskar Ganapathysubramanian", image: baskar, link: "https://www.me.iastate.edu/bglab/" }
  ];

  return (
    <section className="pt-2">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
              <span className="greeting" style={{ fontSize: "2rem" }}>FlowBench Team</span>
              {/* <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>
                THIS SECTION WILL CONTAIN INFORMATION ABOUT THE SOLVER DESCRIPTION
              </p> */}
            </div>

            <div className="row justify-content-center" style={{ marginTop: "2rem" }}>
              {teamMembers.map((member, index) => (
                <div key={index} className="col-md-3 text-center" style={{ marginBottom: "2rem" }}>
                  <div style={{ display: "inline-block", borderRadius: "50%", overflow: "hidden", width: "150px", height: "150px" }}>
                    <img src={member.image} alt={member.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <h5 style={{ marginTop: "1rem" }}>
                    <a href={member.link} target="_blank" rel="noopener noreferrer" style={{ color: "#1a0dab", textDecoration: "none" }}>
                      {member.name}
                    </a>
                  </h5>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default TEAM;
